<template>
  <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px;">
    <div class="d-flex">
      <div class="px-4 ml-auto">لینک پرداخت شخصی</div>
      <div class="px-4">
        <router-link to="/pardakht-shakhsi">
        <personal-payment-svg></personal-payment-svg>
        </router-link>
      </div>
    </div>
    <hr>
    <div class="text-center">
      <div class="my-3 py-3">
        <div class="border rounded-pill mx-auto p-2" style="width: fit-content;">
          <a target="_blank" :href="ps_link"><b class="en_num p-2" style="letter-spacing: 2px;" v-text="ps_link_text"></b></a>
        </div>
      </div>
      <div class="my-3">
        <div id="qr"
        data-toggle="modal"
        data-target="#qr_modal"
        @click="magnifyQR"></div>
      </div>
      <div id="qr_modal" class="modal fade rtl" role="dialog">
          <div class="modal-dialog modal-width">

              <!-- Modal content-->
              <div class="modal-content">
                <div id="data_sheet" class="modal-body mb-4">
                  <div v-show="width < 480" id="qr_for_small_width"></div>
                  <div v-show="width >= 480" class="text-center" id="big_qr"></div>
                </div>
                <div class="modal-footer">
                  <input v-show="!copied" class="form-control p-2" id="ps_link" :value="ps_link_text" style="text-align: center; letter-spacing: 2px;" readonly>
                  <input v-show="copied" class="form-control p-2" value="کپی شد" style="text-align: center;" readonly>
                  <button type="button" class="btn btn-outline-secondary mx-1" @click="copy_ps_link()">کپی کردن</button>
                  <button type="button" class="btn btn-outline-info mx-1" :disabled="disabled_print_qr" @click="print_qr()">چاپ کردن</button>
                </div>
              </div>
          </div>
      </div>
    </div>
    <div id="just_for_print_qr" class="d-none"></div>
  </div>
</template>

<script>
import $ from 'jquery';
import QrCodeWithLogo from "qr-code-with-logo";
import {mapGetters} from "vuex";
import PersonalPaymentSvg from '../../components/svg/PersonalPaymentSvg.vue'

export default {
  name: "pardakht-shakhsi",
  data()
  {
    return {
      copied: false,
      width: window.innerWidth,
      disabled_print_qr: false,
    }
  },
  components:{
    PersonalPaymentSvg
  },
  created() {
    window.addEventListener("resize", this.myResizeEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myResizeEventHandler);
  },
  methods:
  {
    myResizeEventHandler(event) {
      this.width = window.innerWidth;
    },
    print_qr()
    {
      this.disabled_print_qr = true;

      let base_img = document.querySelector('#big_qr > img');

      let img = new Image();
      img.src = base_img.src;

      document.getElementById('just_for_print_qr').appendChild(img);

      let a = window.open('', '', 'height=800, width=1024');
      a.document.write(`
      <html>
      <head>
        <style>
          @font-face {
            font-family: 'IRANSansEnNum';
              src:  url('/assets/new/font/IRANSansWeb_Bold.woff2') format('woff2'),  /* Chrome36+, Opera24+*/
                    url('/assets/new/font/IRANSansWeb_Bold.woff')  format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
                    url('/assets/new/font/IRANSansWeb_Bold.ttf')   format('ttf');
            font-weight: bold;
          }

          @font-face {
            font-family: 'IRANSansFaNum';
              src:  url('/assets/new/font/IRANSansWeb(FaNum)_Bold.woff2') format('woff2'),  /* Chrome36+, Opera24+*/
                    url('/assets/new/font/IRANSansWeb(FaNum)_Bold.woff')  format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
                    url('/assets/new/font/IRANSansWeb(FaNum)_Bold.ttf')   format('ttf');
            font-weight: bold;
          }
          
          * {
            font-family: IRANSansEnNum;
            font-weight: bold;
          }

          .fa_num {
            font-family: IRANSansFaNum !important;
          }

          #print_footer {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 10;
            overflow: hidden;
            padding-right: 32px;
            padding-left: 32px;
            padding-bottom: 16px;
            text-align: center;
          }

          .center_items {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        </style>
      </head>
      <body>
        <div class="center_items" style="padding-top: 40px;">
          <div style="margin: 0 auto; text-align: center;">
      `);
      a.document.write(`<h4 dir="rtl">جهت پرداخت${this.pay_link_title}، بارکد را اسکن یا لینک زیر را در مرورگر وارد کنید.</h4>`);
      a.document.write($('#just_for_print_qr').html());
      a.document.write(`
            <div style="border: 1px #888 solid; border-radius: 20px; width: fit-content; padding: 10px; margin: 10px auto;">
              <span style="padding: 0 10px; letter-spacing: 2px;">${this.ps_link_text}</span>
            </div>
          </div>
        </div>
        <div id="print_footer" dir="rtl">
          <hr>
          <div style="margin-bottom: 10px;">راه های ارتباطی با پشتیبانی شرکت پی استار</div>
          <div class="center_items">
            <div style="width: 33%;" class="center_items">
              <span dir="ltr" class="fa_num">021 91 300 818</span>
              <span style="padding: 0 10px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"/></svg>
              </span>
            </div>
            <div style="width: 33%;" class="center_items">
              <span>www.paystar.ir</span>
              <span style="padding: 0 10px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/></svg>
              </span>
            </div>
            <div style="width: 33%;" class="center_items">
              <span dir="ltr">info@paystar.ir</span>
              <span style="padding: 0 10px;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"/></svg>
              </span>
            </div>
          </div>
        </div>
      </body>
      </html>
      `);
      a.document.close();

      setTimeout(() => {
        a.print();
        $('#just_for_print_qr').empty();
        this.disabled_print_qr = false;
      }, 1000);

    },
    copy_ps_link() {
      let copyText = $("#ps_link");
      copyText.select();
      document.execCommand("copy");

      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 1500);
    },
    magnifyQR() {
      $('#big_qr').empty();
      let width = this.width;
      let qr_size = width * 0.6;

      if (qr_size > 480 || width < 480) {
          qr_size = 480;
      }

      let qr_canvas = document.createElement('img');

      if (width < 480) {
        qr_canvas.style.display = "none";
      }

      document.getElementById('big_qr').appendChild(qr_canvas);

      QrCodeWithLogo.toImage({
        image: qr_canvas,
        content: this.ps_link,
        width: qr_size,
        height: qr_size,
        logo: {
          src: "./favicon_new_dark.png",
          borderRadius: '50',
          bgColor: '#fff',
          logoSize: 0.25,
          borderSize: 0
        }
      });
    },
    createQrCode() {
      setTimeout(() => {
        let qr_canvas = document.createElement('canvas');
        qr_canvas.style.cursor = 'pointer';
        document.getElementById('qr').appendChild(qr_canvas);
        QrCodeWithLogo.toCanvas({
          canvas: qr_canvas,
          content: this.ps_link,
          width: 200,
          height: 200,
          logo: {
            src: "./favicon_new_dark.png",
            borderRadius: '50',
            bgColor: '#fff',
            logoSize: 0.25,
            borderSize: 0
          }
        })
      }, 5);
    },
    createQrCodeForSmallWidth() {
      setTimeout(() => {
        let qr_canvas = document.createElement('canvas');
        qr_canvas.style.cursor = 'pointer';
        document.getElementById('qr_for_small_width').appendChild(qr_canvas);
        QrCodeWithLogo.toCanvas({
          canvas: qr_canvas,
          content: this.ps_link,
          width: 200,
          height: 200,
          logo: {
            src: "./favicon_new_dark.png",
            borderRadius: '50',
            bgColor: '#fff',
            logoSize: 0.25,
            borderSize: 0
          }
        })
      }, 5);
    }
  },
  computed: {
    ps_link_text() {
      return 'PayStar.ir/@' + this.current_user.username;
    },
    ps_link()
    {
      return 'https://paystar.ir/@' + this.current_user.username;
    },
    ...mapGetters('user', [
      'current_user'
    ]),
    ...mapGetters("pardakhtShakhsi", [
      "form_data"
    ]),
    pay_link_title()
    {
      if (this.form_data.show_name_in_qr_print) {
        return ' به ' + this.form_data.pay_link_title;
      } else {
        return '';
      }
    }
  },
  mounted()
  {
    this.$store.dispatch("pardakhtShakhsi/fetch");

    this.createQrCode();
    this.createQrCodeForSmallWidth();
  }
}
</script>

<style scoped>

</style>